import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";

// Add Ram Type
export const addProcessorRamType = createAsyncThunk(
  "ram_type/addProcessorRamType",
  async (data: { ram_type_name: string }, { rejectWithValue }) => {
    try {
      const payload = { ram_type_name: data.ram_type_name.trim() };
      const response: any = await Axios.post(
        "/api/attributes/ram-type/create/",
        payload
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || { message: "Failed to add Ram Type" }
      );
    }
  }
);

// Update Ram Type
export const updateProcessorRamType = createAsyncThunk(
  "ram_type/updateProcessorRamType",
  async (
    { id, ram_type_name }: { id: string; ram_type_name: string },
    { rejectWithValue }
  ) => {
    try {
      const payload = { ram_type_name: ram_type_name.trim() };
      const response: any = await Axios.put(
        `/api/attributes/ram-type/edit/${id}/`,
        payload
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || { message: "Failed to update Ram Type" }
      );
    }
  }
);

// Fetch Ram Type list
export const fetchProcessorRamType = createAsyncThunk(
  "processor_ram_type/fetchProcessorRamType",
  async ({
    page,
    pageSize,
    search,
    sort,
    order,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) params.append("ordering", order === "desc" ? `-${sort}` : sort);

      if (filters?.length) {
        filters.forEach((f: any) => {
          if (f.filterField && f.filterValue != null) {
            params.append(f.filterField, String(f.filterValue));
          }
        });
      }

      const response: any = await Axios.get(
        `api/attributes/ram-type/list/?${params.toString()}`
      );
      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      throw new Error("Failed to fetch Ram Type list");
    }
  }
);

// Fetch Ram Type by ID
export const fetchProcessorRamTypeById = createAsyncThunk(
  "ram_type/fetchProcessorRamTypeById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(
        `/api/attributes/ram-type/edit/${id}/`
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch Ram Type by ID"
      );
    }
  }
);
